import { z } from 'zod';

const directionText = z.string().trim().min(1).max(240);
export const deliveryDirectionSchema = z.object({ emotion: directionText, undertone: directionText, pace: directionText });
export const designDirectionSchema = deliveryDirectionSchema.extend({ gender: directionText, age: directionText, texture: directionText });
export type VoiceDirection = z.infer<typeof deliveryDirectionSchema> & Partial<z.infer<typeof designDirectionSchema>>;

export function parseVoiceDirection(value: unknown, fullDesign: boolean): VoiceDirection {
  return (fullDesign ? designDirectionSchema : deliveryDirectionSchema).parse(value);
}

/** Field allowlists keep cloned voice identity and manual timbre descriptions intact. */
export function voiceDirectionDescription(direction: VoiceDirection, fullDesign: boolean): string {
  const parsed = parseVoiceDirection(direction, fullDesign);
  return [
    ...(fullDesign ? [`性别：${parsed.gender}`, `年龄：${parsed.age}`, `声音质感：${parsed.texture}`] : []),
    `情绪：${parsed.emotion}`, `情绪底色：${parsed.undertone}`, `语速：${parsed.pace}`,
  ].join('；');
}
